export { default } from "./InputComponentNameFields";
